<template>
    <!-- Faulty Part Modal -->
    <b-modal
            body-class="pt-0"
            id="part-faulty-modal"
            no-close-on-backdrop
            no-close-on-esc
            no-footer
            title="Faulty part">

        <!-- Header close button -->
        <template v-slot:modal-header-close>
            <span @click="closeModal">×</span>
        </template>

        <!-- Barcode picker -->
        <div class="row mb-3">
            <barcode-picker @barcodeHasBeenScanned="barcodeScanned($event)" :inModal="true"></barcode-picker>
        </div>

        <!-- Empty state -->
        <empty-state
                v-if="!partScanned"
                icon="scanner"
                title="Scan the faulty part">
        </empty-state>

        <!-- Scanned Part -->
        <template v-if="partScanned">
            <label>Faulty part</label>
            <ul class="list-group">
                <li class="list-group-item">
                    {{ stockItem.title }}
                </li>
            </ul>
        </template>

        <!-- Footer -->
        <template v-slot:modal-footer>
            <button type="button" class="btn btn-light" @click="closeModal">Cancel</button>
            <button type="button" class="btn btn-success" :disabled="!partScanned" @click="partScannedFaulty()">Mark part as faulty</button>
        </template>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {

        props:['jobId', 'deviceId'],

        data() {
            return {
                barcode: null,
                partScanned: false
            }
        },

        computed: {
            ...mapGetters([
                "deviceParts",
                "devicePartsFaulty",
                "stockItem"
            ]),
        },

        mounted() {
            this.clearPartScanned();
        },

        methods: {
            ...mapActions([
                "addPart",
                "destroyBarcodeScanner",
                "displayToast",
                "loadStockItem",
                "markPartAsFaulty"
            ]),

            /** On barcode scanned */
            barcodeScanned(barcode) {
                let haltProcess = false;
                this.partScanned = false;
                this.barcode = barcode;

                this.devicePartsFaulty.forEach(device => {
                    if (barcode.id.toString() === device.id) {
                        this.displayToast({text: 'This part has already been marked as faulty', type: 'danger'});
                        haltProcess = true;
                    }
                });

                if (haltProcess) {
                    return;
                }

                this.loadStockItem({
                    stockItemId: barcode.stock_id
                }).then(() => {
                    this.partScanned = true;
                });
            },

            /** Clear the scanned part */
            clearPartScanned() {
                this.barcode = null;
                this.partScanned = false;
            },

            /** Close the modal */
            closeModal() {
                this.clearPartScanned();
                this.destroyBarcodeScanner()
                    .then(() => {
                        this.$bvModal.hide('part-faulty-modal');
                        this.$emit('close');
                    });
            },

            /** Mark the part as faulty */
            partScannedFaulty() {
                this.addPart({
                    jobId:this.jobId,
                    deviceId: this.deviceId,
                    faulty: true,
                    stockSerialNumberId: this.barcode.id,
                    stockItemId: this.barcode.stock_id,
                    oldSerialNumber: "CNS",
                    newSerialNumber: "CNS"
                }).then(() => {
                    this.clearPartScanned();
                    this.closeModal();
                    this.$emit('partMarkedFaulty');
                })
            },

        }
    }
</script>

<style scoped>

</style>